(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_collection-card"] && !Shopify.designMode) return;
  try {
    (function() {
    var cards = document.querySelectorAll('.ccard--parallax');
    if (!cards.length) return;
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function() {
        cards.forEach(function(card) {
          var rect = card.getBoundingClientRect();
          if (rect.bottom > 0 && rect.top < window.innerHeight) {
            var progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
            var offset = (progress - 0.5) * 24;
            card.style.setProperty('--ccard-parallax-y', offset + 'px');
          }
        });
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_slide"] && !Shopify.designMode) return;
  try {
    (function() {
    var containers = document.querySelectorAll('[data-slide-content].slide__content--animated');
    if (!containers.length) return;

    /* Observe active slide changes via slideshow-slide[active] */
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        if (m.attributeName === 'active' || m.attributeName === 'aria-hidden') {
          var slide = m.target.closest('slideshow-slide');
          if (!slide) return;
          var content = slide.querySelector('[data-slide-content]');
          if (!content) return;
          if (slide.hasAttribute('active') || slide.getAttribute('aria-hidden') === 'false') {
            content.classList.add('is-visible');
          }
        }
      });
    });

    document.querySelectorAll('slideshow-slide').forEach(function(slide) {
      observer.observe(slide, { attributes: true, attributeFilter: ['active', 'aria-hidden'] });
      /* Initial check */
      if (slide.hasAttribute('active')) {
        var c = slide.querySelector('[data-slide-content]');
        if (c) setTimeout(function() { c.classList.add('is-visible'); }, 100);
      }
    });

    /* Parallax for slides with that option */
    var parallaxContainers = document.querySelectorAll('.slide__image-container--parallax');
    if (parallaxContainers.length) {
      var ticking = false;
      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function() {
          parallaxContainers.forEach(function(container) {
            var rect = container.getBoundingClientRect();
            if (rect.bottom > 0 && rect.top < window.innerHeight) {
              var progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
              var offset = (progress - 0.5) * 30;
              container.style.setProperty('--slide-parallax-y', offset + 'px');
            }
          });
          ticking = false;
        });
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
